module.exports = __webpack_public_path__ + "img/clearStyle.960c9c49.svg";